"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NoAvailabilitySupport = require("./NoAvailabilitySupport");
Object.keys(_NoAvailabilitySupport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NoAvailabilitySupport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NoAvailabilitySupport[key];
    }
  });
});
var _useNoAvailabilitySupport = require("./useNoAvailabilitySupport");
Object.keys(_useNoAvailabilitySupport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useNoAvailabilitySupport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useNoAvailabilitySupport[key];
    }
  });
});